module.exports = __webpack_public_path__ + "817dc2d1c21213154db6587328726a02.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/theme/images/default-img.jpg
// module id = 1441
// module chunks = 47